import { combineReducers } from 'redux';
import user from './modules/user/reducer';
import stock from './modules/stock/reducer';

const reducers = combineReducers({ user, stock });

export default reducers;
